import HttpService from './../http-service';
import { buildApi } from '../http-client/http-client';
import { toQueryParams } from '../..';

HttpService.defaults.baseURL = process.env.BLOG_BASE_URL;

export const getCategories = (page = 1, perPage = 10) =>
  buildApi().get(`${process.env.BLOG_BASE_URL}/wp-json/wp/v2/categories?page=${page}&per_page=${perPage}`);

export const getPosts = (page = 1, perPage = 10, categories = [], query = '') => {
  let params = {
    page,
    per_page: perPage,
    search: query,
  };
  if (categories.length > 0) {
    params = {
      ...params,
      categories: categories.join(),
    };
  }

  return HttpService.get(`/wp-json/wp/v2/posts?${toQueryParams(params)}`).then(({ data, headers }) => ({
    resources: data,
    meta: {
      total: headers['x-wp-total'],
      last_page: headers['x-wp-totalpages'],
    },
  }));
};

export const getPost = postId => buildApi().get(`${process.env.BLOG_BASE_URL}/wp-json/wp/v2/posts/${postId}`);

export const getMedia = mediaId => buildApi().get(`${process.env.BLOG_BASE_URL}/wp-json/wp/v2/media/${mediaId}/`);

export const getMediaFromPost = postId =>
  buildApi().get(`${process.env.BLOG_BASE_URL}/wp-json/wp/v2/media?parent=${postId}`);

export const getCategoriesFromPost = postId =>
  buildApi().get(`${process.env.BLOG_BASE_URL}/wp-json/wp/v2/categories?post=${postId}`);

export default { getPosts, getPost, getMedia, getMediaFromPost, getCategoriesFromPost };
